import React from 'react';
import * as Toast from '@radix-ui/react-toast';
import {ERROR, INFO, SUCCESS, useAppStore} from 'stores/app';
import {twMerge} from 'tailwind-merge';
import {Close} from 'Icons/Close';

interface Props {}

export const ToastHandler: React.FC<Props> = () => {
    const toast = useAppStore.use.toast();
    const clearToast = useAppStore.use.clearToast();
    return (
        <Toast.Provider duration={5000} swipeDirection="down">
            <Toast.Root
                className={twMerge(
                    'data-[state=open]:animate-slideIn data-[state=closed]:animate-hide data-[swipe=end]:animate-swipeOut',
                    'data-[swipe=cancel]:translate-y-0 data-[swipe=move]:translate-y-[var(--radix-toast-swipe-move-y)] data-[swipe=cancel]:transition-[transform_200ms_ease-out]',
                    'flex items-center justify-between gap-2 rounded-2xl p-[15px]',
                    toast.type === SUCCESS && 'bg-[#D8FFCA] shadow-[0_0_5px_0_#D8FFCA]',
                    toast.type === ERROR && 'bg-[#FFCACA] shadow-[0_0_5px_0_#FFCACA]',
                    toast.type === INFO && 'bg-[#CAECFF] shadow-[0_0_5px_0_#CAECFF]'
                )}
                open={toast.open}
                onOpenChange={(open) => !open && clearToast()}
            >
                <Toast.Description asChild>
                    <p className="m-0 w-full truncate text-[12px] text-[#373737]">{toast.message}</p>
                </Toast.Description>
                <Toast.Action className="[grid-area:_action]" asChild altText="Clear error">
                    <button
                        className={twMerge(
                            'flex items-center justify-center justify-self-end rounded-full p-1 ring-[#373737] hover:ring-1  focus:shadow-[0_0_0_2px] focus:shadow-[#373737]'
                        )}
                    >
                        <Close color="#373737" width={10} height={10} />
                    </button>
                </Toast.Action>
            </Toast.Root>
            <Toast.Viewport className="fixed bottom-0 left-1/2 right-1/2 z-[2147483647] m-0 flex w-[55vw] max-w-[80vw] -translate-x-1/2 list-none flex-col gap-[10px] p-[var(--viewport-padding)] outline-none [--viewport-padding:_25px]" />
        </Toast.Provider>
    );
};
